import { render, staticRenderFns } from "./r-worker-kind.vue?vue&type=template&id=23478972"
import script from "./r-worker-kind.vue?vue&type=script&lang=js"
export * from "./r-worker-kind.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23478972')) {
      api.createRecord('23478972', component.options)
    } else {
      api.reload('23478972', component.options)
    }
    module.hot.accept("./r-worker-kind.vue?vue&type=template&id=23478972", function () {
      api.rerender('23478972', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/worker/r-worker-kind.vue"
export default component.exports